import LoopStage from '@/modules/content/loop/parts/LoopStage';
import PortraitFrame from '@/modules/content/loop/parts/PortraitFrame';
import TextColumn from '@/modules/content/loop/parts/TextColumn';
import VideoFrame from '@/modules/content/loop/parts/VideoFrame';
import { TLoopReelProps } from '@/modules/content/loop/model/types';

// Reel · portrait — text column on the left, tall video on the right. Mux uploads and
// YouTube Shorts.
const PortraitReel = ({
  content,
  isActive,
  onNotInterested,
  onReport,
  onRatioDetected,
  onPlayStateChange,
  onProgress,
  ratio,
  rail,
  nav,
}: TLoopReelProps) => (
  <LoopStage
    left={<TextColumn content={content} onNotInterested={onNotInterested} onReport={onReport} isDimmed />}
    center={
      <PortraitFrame ratio={ratio}>
        <VideoFrame
          content={content}
          isActive={isActive}
          onRatioDetected={onRatioDetected}
          onPlayStateChange={onPlayStateChange}
          onProgress={onProgress}
        />
      </PortraitFrame>
    }
    right={
      <>
        {rail}
        {nav}
      </>
    }
  />
);

export default PortraitReel;
